module.exports = __webpack_public_path__ + "asset/img/pic01.3b8373fe.gif";